import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { useApp } from '../../context/AppContext';
import './QRCode.css';

const GPT_URL = 'https://chatgpt.com/g/g-a5ZiZ1gfA-meet-david-luquin';

const QRCode: React.FC = () => {
  const { lang } = useApp();

  return (
    <div className="qr-block">
      <div className="qr-block__code">
        <QRCodeSVG
          value={GPT_URL}
          size={120}
          bgColor="#FFFFFF"
          fgColor="#000000"
          level="M"
        />
      </div>
      <div className="qr-block__info">
        <p className="qr-block__label">
          {lang === 'es' ? 'Habla con David' : 'Talk to David'}
        </p>
        <p className="qr-block__sublabel">
          {lang === 'es'
            ? 'Mi asistente IA personal'
            : 'My personal AI assistant'}
        </p>
        <a
          href={GPT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="qr-block__link"
        >
          {lang === 'es' ? 'Abrir ChatGPT →' : 'Open ChatGPT →'}
        </a>
      </div>
    </div>
  );
};

export default QRCode;
